import { MaskService } from '../../../../../shared/services/mask.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxCurrencyDirective } from 'ngx-currency';

import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { AutocompletePesquisavelComponent } from '../../../../../shared/components/autocomplete-pesquisavel/autocomplete-pesquisavel.component';
import { CategoriaFinanceira } from '../../../../../shared/services/models/financas/categoria-financeira.model';
import { environment } from '../../../../../../environments/environment';
import { TipoContatoEnum } from '../../../../../shared/enums/pessoa/tipo-contato.enum';

@Component({
  selector: 'app-contas-pagar-dados-gerais',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxCurrencyDirective,
    SelectPesquisavelComponent,
  ],
  templateUrl: './contas-pagar-dados-gerais.component.html',
  styleUrl: './contas-pagar-dados-gerais.component.css',
})
export class ContasPagarDadosGeraisComponent implements OnInit {
  @Input() parentForm!: FormGroup;
  @Input() listaCategoriasFinanceiras: CategoriaFinanceira[] = [];
  @Input() currencyMask: any;

  public urlFornecedor = `${environment.urlApiPessoa}Lookup/listPessoaSelect?idTipoContato=${TipoContatoEnum.Fornecedor}`;

  get dadosGeraisGroup(): FormGroup {
    return this.parentForm.get('dadosGerais') as FormGroup;
  }

  get idFornecedorControl(): any {
    return this.dadosGeraisGroup.get('idFornecedor');
  }
  get idCategoriaFinanceiraControl(): any {
    return this.dadosGeraisGroup.get('idCategoriaFinanceira');
  }

  constructor() { }

  ngOnInit(): void { }

  onDateInput(event: Event, controlName: string): void {
    MaskService.onDateInput(event, this.dadosGeraisGroup.get(controlName));
  }
}
